// src/pages/vendas/NaturezaSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useNatureza } from '../../contexts/vendas/NaturezaContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const NaturezaSearch = ({ show, onHide, onSelectNatureza }) => {
    const { naturezas } = useNatureza();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            inputRef.current?.focus();
        }
    }, [show]);

    if (!show) return null;

    const filteredNaturezas = naturezas.filter(n =>
        n.descricao.toLowerCase().includes(filter.toLowerCase())
    );

    const sortedNaturezas = [...filteredNaturezas].sort((a, b) => {
        if (sortField === 'id') return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        if (sortField === 'descricao') {
            return sortDirection === 'asc'
                ? a.descricao.localeCompare(b.descricao)
                : b.descricao.localeCompare(a.descricao);
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (natureza) => {
        onSelectNatureza(natureza);
        onHide();
    };

    return (
        <ModalContainer show={show} zIndex={1060} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Natureza" onHide={onHide} />

            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedNaturezas} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('id')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Id {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" style={{ width: '60%' }} aria-sort={sortField === 'descricao' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('descricao')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                 type="button">
                                    Descrição {sortField === 'descricao' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" style={{ width: '20%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((natureza) => (
                            <tr key={natureza.id} onDoubleClick={() => handleDoubleClick(natureza)}>
                                <td className="text-end align-middle">{natureza.id}</td>
                                <td className="text-start align-middle">{natureza.descricao}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectNatureza(natureza)} style={{ padding: '2px 6px' }} label={natureza.descricao} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>

            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default NaturezaSearch;
